<template>
  <div class="manager_box">
    <el-form
      ref="form"
      id="form_div"
      :rules="rules"
      :model="form"
      label-width="80px"
    >
      <div class="form_item">
        <el-form-item
          label="登录账号"
          prop="username"
          class="label_form_item"
          label-width="100px"
        >
          <el-input
            type="number"
            oninput="if(value.length>5)value=value.slice(0,11)"
            class="input_width"
            v-model="form.username"
            placeholder="登录账号（手机号）"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="登录密码"
          prop="password"
          class="label_form_item"
          label-width="100px"
        >
          <el-input
            class="input_width"
            v-model="form.password"
            placeholder="请填写密码"
          ></el-input>
        </el-form-item>
      </div>
      <div class="form_item">
        <el-form-item
          label="姓名"
          prop="name"
          class="label_form_item"
          label-width="100px"
        >
          <el-input
            class="input_width"
            v-model="form.name"
            placeholder="请填写姓名"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="公司名称"
          prop="company_name"
          class="label_form_item"
          label-width="100px"
        >
          <el-input
            class="input_width"
            v-model="form.company_name"
            placeholder="请填写公司名称"
          ></el-input>
        </el-form-item>
      </div>
      <div class="form_item">
        <el-form-item
          label="经纪人数"
          prop="middle_count"
          class="label_form_item"
          label-width="100px"
        >
          <el-input
            type="number"
            class="input_width"
            v-model="form.middle_count"
            placeholder="请填写经纪人数量"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="职员人数"
          prop="es_count"
          class="label_form_item"
          label-width="100px"
        >
          <el-input
            type="number"
            class="input_width"
            v-model="form.es_count"
            placeholder="请填写职员数量"
          ></el-input>
        </el-form-item>
      </div>
      <div class="form_item">
        <el-form-item
          label="开始时间"
          prop="vip_start_time"
          class="label_form_item"
          label-width="100px"
        >
          <el-date-picker
            class="input_width"
            value-format="timestamp"
            v-model="form.vip_start_time"
            type="date"
            placeholder="开始时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          label="结束时间"
          prop="vip_end_time"
          class="label_form_item"
          label-width="100px"
        >
          <el-date-picker
            class="input_width"
            value-format="timestamp"
            v-model="form.vip_end_time"
            type="date"
            placeholder="结束时间"
          ></el-date-picker>
        </el-form-item>
      </div>
      <div class="form_item">
        <el-form-item
          label="公司所在地"
          prop="region"
          class="label_form_item"
          label-width="100px"
        >
          <el-cascader
            class="input_width"
            v-model="form.region"
            :options="options"
            @change="handleChange"
          ></el-cascader>
        </el-form-item>

        <el-form-item
          label="权限"
          prop="jurisdiction"
          class="label_form_item"
          label-width="100px"
        >
          <el-radio-group v-model="form.jurisdiction" @change="jurisdictionFn">
            <el-radio :label="0">下载账号</el-radio>
            <el-radio :label="3">管理账号</el-radio>
            <el-radio :label="1">省代</el-radio>
            <el-radio :label="2">代理商</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>

      <!-- <el-form-item label="是否是测试账号" class="label_form_item" label-width="120px"> -->
      <!-- <el-switch v-model="value" active-color="#13ce66" inactive-color="#ff4949"> </el-switch> -->
      <!-- <el-switch
            v-model="value"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="是"
            inactive-text="不是"
            @change="test_account_number"
          ></el-switch>
        </el-form-item> -->
      <div class="form_item">
        <el-form-item
          label="营业执照"
          prop="imageUrl"
          class="label_form_item"
          label-width="100px"
        >
          <el-upload
            class="avatar-uploader"
            :action="url_Api + '/hr24_user/v1/upload_file/'"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
          >
            <img
              v-if="form.imageUrl"
              :src="form.imageUrl.file_url"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item
          label="代理商"
          prop="agent"
          class="label_form_item"
          label-width="100px"
        >
          <el-cascader
            class="input_width"
            v-model="form.agent"
            :options="list_agent"
            @change="agentChange"
          ></el-cascader>
        </el-form-item>
      </div>
      <div class="button_div">
        <el-button type="primary" class="establish" @click="lwbus_establish"
          >创建账号</el-button
        >
      </div>
    </el-form>
  </div>
</template>

<script>
import axios from "axios";
import { require, url_Api } from "@/utils/http_request.js";
export default {
  data() {
    return {
      value: false,
      form: {
        username: "", // 用户登录账号
        password: "", // 用户密码
        name: "", // 用户姓名
        company_name: "", // 公司名称
        middle_count: "", // 经济人数
        es_count: "", // 职员人数
        region: [], // 公司所在地
        jurisdiction: 0, //权限ID
        agent: "", //代理商
        // province_id,  // city_id, // district_id
        vip_start_time: "", // 会员开始时间
        vip_end_time: "", // 会员结束时间
        is_experience: 0, // 是否是测试账号
        imageUrl: "",
      },
      options: [],
      list_agent: [],
      rules: {
        username: [
          { required: true, message: "请填写用户登录账号", trigger: "blur" },
          { min: 11, max: 11, message: "用户名11个数字", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请填写用户密码", trigger: "blur" },
          { min: 6, message: "密码最少6位", trigger: "blur" },
        ],
        name: [{ required: true, message: "请填写用户姓名", trigger: "blur" }],
        company_name: [
          { required: true, message: "请填写公司名称", trigger: "blur" },
        ],
        middle_count: [
          { required: true, message: "请填写经济人数", trigger: "blur" },
        ],
        es_count: [
          { required: true, message: "请填写职员人数", trigger: "blur" },
        ],
        region: [
          { required: true, message: "请选择公司所在地", trigger: "blur" },
        ],
        agent: [{ required: true, message: "请选择代理商", trigger: "blur" }],
     
        jurisdiction: [
          { required: true, message: "请选择权限", trigger: "blur" },
        ],
        vip_start_time: [
          { required: true, message: "请选择会员开始时间", trigger: "blur" },
        ],
        vip_end_time: [
          { required: true, message: "请选择会员结束时间", trigger: "blur" },
        ],
        imageUrl: [
          { required: true, message: "请上传营业执照", trigger: "change" },
        ],
      },
    };
  },
  created() {
    this.url_Api = url_Api;
    this.agent_list();
    require("post", "/commonality/v1/show_place_json/", { is_add: 0 }).then(
      (res) => {
        console.log(res);
        if (res.code == 0) {
          this.options = res.data;
        }
      }
    );
  },
  methods: {
    agentChange() {
      console.log(this.form.agent[this.form.agent.length - 1]);
    },
    agent_list() {
      this.form.agent = "";
      require("post", "/lwbus_user/v1/agent_list/", {
        type: this.form.jurisdiction,
      }).then((res) => {
        if (res.code == 0) {
          this.list_agent = res.data;
        }
      });
    },
    jurisdictionFn() {
      this.agent_list();
    },
    handleAvatarSuccess(res, file) {
      //   this.imageUrl =
      if (!res.code) {
        this.form.imageUrl = res.data.file_data;
      }
    },

    handleChange(value) {
      console.log(value);
    },
    test_account_number(e) {
      // 是否是测试账号
      if (e) {
        this.form.is_experience = 1;
      } else {
        this.form.is_experience = 0;
      }
    },
    lwbus_establish() {
      if (
        this.form.username == "" ||
        this.form.username.length != 11 ||
        this.form.password == "" ||
        this.form.password.length < 6 ||
        this.form.name == "" ||
        this.form.company_name == "" ||
        this.form.region.length == 0 ||
        this.form.region == "" ||
        this.form.vip_start_time == "" ||
        this.form.vip_end_time == "" ||
        this.form.middle_count == "" ||
        this.form.es_count == "" ||
        this.form.imageUrl == "" ||
        this.form.agent == ""
      ) {
        this.$message.error("请将信息填写完整");
        return false;
      }
      require("post", "/lwbus_user/v1/lwbus_register_user/", {
        register_data: {
          username: this.form.username,
          password: this.form.password,
          name: this.form.name,
          company_name: this.form.company_name,
          middle_count: this.form.middle_count,
          es_count: this.form.es_count,
          province_id: this.form.region[0],
          city_id: this.form.region[1],
          district_id: this.form.region[2],
          vip_start_time: this.form.vip_start_time / 1000,
          vip_end_time: this.form.vip_end_time / 1000,
          is_experience: this.form.is_experience,
          license: this.form.imageUrl.file_id,
          attributes: this.form.jurisdiction,
          belong_agent_id: this.form.agent[this.form.agent.length - 1],
        },
      }).then((res) => {
        if (!res.code) {
          this.$message({
            message: res.msg,
            type: "success",
          });
          this.form = {
            username: "", // 用户登录账号
            password: "", // 用户密码
            name: "", // 用户姓名
            company_name: "", // 公司名称
            middle_count: "", // 经济人数
            es_count: "", // 职员人数
            region: [], // 公司所在地
            // province_id,  // city_id, // district_id
            vip_start_time: "", // 会员开始时间
            vip_end_time: "", // 会员结束时间
            is_experience: 0, // 是否是测试账号
            imageUrl: "",
            jurisdiction: 0, //权限ID
            agent: "", //代理商
          };
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style>
#form_div {
  padding: 20px;
}
#form_div .form_item {
  padding: 10px 0;
  display: flex;
}
#form_div .form_item .label_form_item {
  flex: 1;
  width: 500px;
  margin: 6px 20px;
}
#form_div .button_div {
  width: 100%;
  margin: 20px;
  display: flex;
  justify-content: center;
}
#form_div .button_div .establish {
  margin: 0 80px;
  padding: 10px 30px;
  font-size: 18px;
}
#form_div .input_width {
  width: 350px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/lwbus/establish.vue